import React from 'react'
import '../../pages/Portfolio/Portfolio.scss'
import TopNav from "../TopNav/TopNav";
import {Fade} from 'react-reveal'
import Spin from 'react-reveal/Spin';
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const portfolio = assetUrl+'images/portfolio_2x.png'
const star = assetUrl+'images/Star_2x.png'
const arrow = assetUrl+'images/arrow-white-md.png'

const CreatePortfolio = (props) => {
    const createPort = "createPort-"
    return (
        <div>
            <TopNav/>
            <div className={createPort + "bg text-center"}>
                <div style={{paddingTop:"50%"}} className={createPort+"image-animate-wrap"}>
                    <Fade>
                        <div className={createPort + "imageWrapper mx-auto"}>
                            <img alt={"alt"} src={portfolio} className={createPort + "breifcase"}/>
                            <Spin  delay={300}>
                                <img alt={"alt"} src={star} className={createPort + "star"}/>
                            </Spin>
                        </div>
                    </Fade>
                </div>


                <p className={createPort + "heading"}>Create Portfolio</p>
                <p className={createPort + "subtext"}>Start Investing to create your Portflio</p>

                <button onClick={props.createNewPortfolio} className={createPort + "button mx-auto"}>Create Now
                    <img alt={'alt'} src={arrow}  className={createPort + "button_image"} style={{marginLeft:"8px"}}/>
                </button>
            </div>
        </div>
    )
}

export default withRouter(CreatePortfolio);
